// Notifications plugin. Used on Notifications page
// import Notifications from "@/components/NotificationPlugin";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "./components/SidebarPlugin";
// Tabs plugin. Used on Panels page.
import VueProgressiveImage from "vue-progressive-image";
// Vue ability for permission
import { abilitiesPlugin } from "@casl/vue";
import ability from "./helpers/ability";
import Loading from "vue-loading-overlay";
import Notifications from "vue-notification";
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/vi";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import { Settings } from "luxon";
Settings.defaultLocale = "vi";

import VueMaterial from "vue-material";

// asset imports
import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";
import "./assets/css/demo.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-datetime/dist/vue-datetime.css";

// library auto imports
import "es6-promise/auto";

import htmlToPdf from "./core/utils/htmlToPdf.js";

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(VueMaterial);
    Vue.use(SideBar);
    Vue.use(VueProgressiveImage, {
      delay: 2000 // 2 seconds before the image is displayed
    });
    Vue.use(abilitiesPlugin, ability);
    Vue.use(Loading);
    Vue.use(Notifications);
    Vue.use(CKEditor);
    Vue.use(htmlToPdf);
  }
};
